import './App.css';
import Header from './components/sections/Header';
import HeroCarousel from './components/sections/HeroCarousel';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import StorySection from './components/sections/StorySection';
import ArtSection from './components/sections/ArtSection';
import Organize from './components/sections/Organize';
import OurCreations from './components/sections/OurCreations';
import TestiMonials from './components/sections/TestiMonials';
import Contact from './components/sections/Contact';
import Footer from './components/sections/Footer';

function App() {
  return (
    <div className="App">
      <Header/>
      <HeroCarousel/>      
      <StorySection/>
      <ArtSection/>
      <Organize/>
      <OurCreations/>
      <TestiMonials/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
